/* SPDX-FileCopyrightText: 2014-present Kriasoft */
/* SPDX-License-Identifier: MIT */

import { Tooltip } from "@mui/joy";

/** Wraps children in a right-placed tooltip only when `enabled` is true. */
export function MaybeTooltip({
  title,
  enabled,
  children,
}: {
  title: string;
  enabled: boolean;
  children: JSX.Element;
}): JSX.Element {
  if (!enabled) return children;
  return (
    <Tooltip title={title} placement="right" size="sm">
      {children}
    </Tooltip>
  );
}
